import isApiError from "@insite/client-framework/Common/isApiError";
import { get, ServiceResult } from "@insite/client-framework/Services/ApiService";

const url = "api/v2/quickexpert";

export async function GETChatExpertImage(): Promise<ServiceResult<any>> {
    try {
        const result = await get(url);
        return {
            successful: true,
            result,
        };
    } catch (error) {
        if (isApiError(error) && error?.status === 400 && error?.errorJson && error?.errorJson.message) {
            return {
                successful: false,
                errorMessage: error?.errorJson.message,
            };
        }
        throw error;
    }
}
